// extracted by mini-css-extract-plugin
module.exports = {"containerBg":"OrdinancesAdministration_containerBg__12ffv","dataContainer":"OrdinancesAdministration_dataContainer__2ORb6"};